import React, { useState, useEffect, useRef, use } from 'react';
import { NavLink, useParams, useNavigate} from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { savePermisosPaginas, getPermisosPaginas } from './../Utils/indexedDBUtils';
import { jsPDF } from 'jspdf';
import GetPaginaUno from './PaginasDx/GetPaginaUno.jsx';
import GetPaginaDos from './PaginasDx/GetPaginaDos.jsx';
import GetPaginaTres from './PaginasDx/GetPaginaTres.jsx';
import GetPaginaCuatro from './PaginasDx/GetPaginaCuatro.jsx';
import GetPaginaCinco from './PaginasDx/GetPaginaCinco.jsx';
import GetPaginaSeis from './PaginasDx/GetPaginaSeis.jsx';
import GetPaginaSiete from './PaginasDx/GetPaginaSiete.jsx';
import GetPaginaOcho from './PaginasDx/GetPaginaOcho.jsx';
import GetPaginaDiez from './PaginasDx/GetPaginaDiez.jsx';
import GetPaginaOnce from './PaginasDx/GetPaginaOnce.jsx';
import GetPaginaDoce from './PaginasDx/GetPaginaDoce.jsx';
import GetPaginaTrece from './PaginasDx/GetPaginaTrece.jsx';
import { Card } from 'react-bootstrap';
import GetPaginaSeisB from './PaginasDx/GetPaginaSeisB.jsx';
 
export default function ReporteDxSemana(){
    const navigate = useNavigate();
    const { token, rol, user, fetchPermisosPaginas } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { id } = useParams();
    const [swalProps, setSwalProps] = useState();
    const [permisosPaginas, setPermisosPaginas] = useState([]);
    const [datosReporte, setDatosReporte] = useState(null);
    const consultarPermisosPaginas = React.useCallback(async () => {
        const cachedPermisos = await getPermisosPaginas();
        if (cachedPermisos) {
            setPermisosPaginas(cachedPermisos);
        } else {
            // If not in IndexedDB, fetch from the API
            const permisos = await fetchPermisosPaginas();
            if (permisos) {
                setPermisosPaginas(permisos);
                await savePermisosPaginas(permisos); // Save the result to IndexedDB
            }
        }
    }, [fetchPermisosPaginas]);
    
    useEffect(() => {
        consultarPermisosPaginas();
    }, [consultarPermisosPaginas]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };

    const canvasRef = useRef(null);
    const canvasRefDos = useRef(null);
    const canvasRefTres = useRef(null);
    const canvasRefCuatro = useRef(null);
    const canvasRefCinco = useRef(null);
    const canvasRefSeis = useRef(null);
    const canvasRefSeisB = useRef(null);
    const canvasRefSiete = useRef(null);
    const canvasRefOcho = useRef(null);
    const canvasRefOchoB = useRef(null);
    const canvasRefDiez = useRef(null);
    const canvasRefOnce = useRef(null);
    const canvasRefDoce = useRef(null);
    const canvasRefTrece = useRef(null);

    useEffect(() => {
      // draw initial with provided observation text
      canvasRef.current?.draw({
        title: 'Desplazamiento Forzado',
        subTitle: 'en Medellín',
        TituloObservacion: `Informe Semanal | del ${datosReporte?.fechaSemanaActual || ''}`,
        observations:
          `Construido con base en los registros del Equipo de Atención y Reparación a Víctimas (EARV), referentes a la atención de personas que declaran hechos victimizantes ante la Personería, Defensoría o Procuraduría, ocurridos en los últimos tres meses anteriores a la atención, según lo ordenado por la Ley 1448 de 2011, artículo 47, modificado por la Ley 2421 de 2024.`,
        logoSrc: '/dist/img/logo_login.png'
      });
      canvasRefDos.current?.draw({
        title: 'Contenido',
        // content as array (four items + Glosario)
        content: [
          'Recepción en Medellín de población desplazada',
          'Desplazamiento Forzado Intraurbano (DFI)',
          'Advertencias sobre posibles riesgos',
          'Glosario'
        ],
        footerText: "Datos calculados y presentados según la fecha en la que se realizó la atención.",
        tipoInforme: "Semanal",
        logoSrc: '/dist/img/logo_login.png'
      });
      canvasRefTres.current?.draw({
        title: 'Recepción en Medellín de población desplazada',
        tipoReporte: 'semanal',
        textoUno: '*Estos datos no incluyen los Desplazamientos Forzados Intraurbanos (DFI).',
        content: [
          [
            {title: 'SemanaActual', text: 'Semana actual'}, 
            {title: 'Fecha', text: datosReporte?.fechaSemanaActual || ''},
            {title: 'Hogar', text:  `${datosReporte?.datosPaginaTres.hogaresSemanaActual || 0} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasSemanaActual || 0} personas`},
          ],
          [
            {title: 'AnioActual', text: 'Año actual'}, 
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres.fechaAnioActual || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresAnioActual || 0} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasAnioActual || 0} personas`},
          ],
          [
            {title: 'SemanaAnterior', text: 'Semana anterior'},
            {title: 'Fecha', text: `${datosReporte?.fechaSemanaAnterior || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresSemanaAnterior || 0} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasSemanaAnterior || 0} personas`},
          ],
          [
            {title: 'Variacion', text: 'Variación'},
            {title: 'ObsVariacion', text: 'Con respecto a la semana anterior'},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.variacionSemanaHogares > 0 ? '+' : ''}${datosReporte?.datosPaginaTres.variacionSemanaHogares || ''} hogares`},
            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres.porcentajeVariacionSemanaHogares || ''}%)`},
          ],
          [
            {title: 'AnioAnterior', text: 'Año anterior'},
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres.fechaAnioAnterior || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresAnioAnterior || 0} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasAnioAnterior || 0} personas`},
          ],
          [
            {title: 'Variacion', text: 'Variación'},
            {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.variacionAnioHogares > 0 ? '+' : ''}${datosReporte?.datosPaginaTres.variacionAnioHogares || ''} hogares`},
            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres.porcentajeVariacionAnioHogares || ''}%)`},
          ],
        ],
        logoSrc: '/dist/img/logo_login.png',
        cardIcons: [
          '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
          '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
          '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
          '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
        ]
      });
      canvasRefCuatro.current?.draw({
        title: 'Recepción de población desplazada proveniente de otros municipios de ANTIOQUIA',
        subTitle: '',
        textoUno: 'Tabla 1. Principales subregiones con mayor expulsión de población desplazada proveniente de Antioquia con recepción en Medellín, semana actual.',
        textoDos: '',
        logoSrc: '/dist/img/logo_login.png',
        tableData: datosReporte?.datosPaginaCuatro?.rows?.map(item => ({
            subregion: item.subregion,
            municipio: item.municipio,
            totalHogares: String(item.totalHogares),
            totalPersonas: String(item.totalPersonas),
        })) || [],
        resumenTabla: [
          { label: 'Total Antioquia (sin Medellín)', value: `${datosReporte?.datosPaginaCuatro?.hogaresDepartamento ?? ''} Hogares` },
          { label: 'Porcentaje en Antioquia (sin Medellín)', value: `${datosReporte?.datosPaginaCuatro?.porcentajeHogares ?? ''} %` },
        ]
      });
      canvasRefCinco.current?.draw({
        title: 'Recepción de población desplazada proveniente de OTROS DEPARTAMENTOS',
        subTitle: '',
        textoUno: 'Tabla 2. Principales departamentos expulsores de población desplazada con recepción en Medellín, semana actual.',
        textoDos: '',
        logoSrc: '/dist/img/logo_login.png',
        tableData: datosReporte?.datosPaginaCinco?.rows?.map(item => ({
            departamento: item.departamento,
            municipio: item.municipio,
            totalHogares: String(item.hogares_count),
            totalPersonas: String(item.total_personas),
            totalPersonasDepartamento : String(item.totalPersonasDepartamento),
        })) || [],
        resumenTabla: [
          { label: 'Total otros departamentos', value: `${datosReporte?.datosPaginaCinco?.hogaresOtrosDepartamento ?? ''} Hogares` },
          { label: 'Porcentaje de otros departamentos', value: `${datosReporte?.datosPaginaCinco?.porcentajeHogares ?? ''} %` },
        ]
      });
      canvasRefSeis.current?.draw({
        title:"Recepción de población desplazada proveniente de otros municipios y departamentos",
        subTitle:"Caracteristicas diferenciales - Identidad ÉTNICA",
        graficaUnoData : datosReporte?.datosPaginaSeis?.etnias?.map(item => ({
          categoria: item.min_minoria,
          valor: item.count,
        })) || [],
        graficaDosData: datosReporte?.datosPaginaSeis?.porDepartamento?.map(item => ({
          departamento: item.departamento,
          categoria: item.min_minoria,
          valor: item.count,
        })) || [],
        textoUno:"Gráfica 1. Personas atendidas según Identidad étnica otros municipios diferentes de Medellín, semana actual.",
        textoDos:"Gráfica 2. Identidad étnica de las personas atendidos otros departamentos, semana actual.",
        footerText:"*NARP: Población Negra, Afrocolombiana, Raizal y Palenquera.",
        logoSrc:"/dist/img/logo_login.png",
      });
      canvasRefSeisB.current?.draw({
        title: datosReporte?.datosPaginaSeisB?.title ?? '',
        subTitle: datosReporte?.datosPaginaSeisB?.subTitle ?? '',
        graficaUnoData: datosReporte?.datosPaginaSeisB?.graficaUnoData ?? [],
        graficaDosData: datosReporte?.datosPaginaSeisB?.graficaDosData ?? [],
        graficaTresData: datosReporte?.datosPaginaSeisB?.graficaTresData ?? [],
        textoGraficoUno: datosReporte?.datosPaginaSeisB?.textoGraficoUno ?? '',
        textoGraficoDos: datosReporte?.datosPaginaSeisB?.textoGraficoDos ?? '',
        textoGraficoTres: datosReporte?.datosPaginaSeisB?.textoGraficoTres ?? '',
        textoCualitativo: [
            datosReporte?.datosPaginaSeisB?.textoCualitativo ?? '',
            datosReporte?.datosPaginaSeisB?.textoCualitativoUno ?? '',
            datosReporte?.datosPaginaSeisB?.textoCualitativoDos ?? '',
            datosReporte?.datosPaginaSeisB?.textoCualitativoTres ?? '',
        ],
        titleSquareText:"1.4",
        logoSrc:"/dist/img/logo_login.png",
      });
      canvasRefSiete.current?.draw({
        title: 'Desplazamiento Forzado Intraurbano',
        content: [
          [
            {title: 'SemanaActual', text: 'Semana actual'},
            {title: 'Fecha', text: datosReporte?.fechaSemanaActual || ''},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresSemanaActual || '0'} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasSemanaActual || '0'} personas`},
          ],
          [
            {title: 'AnioActual', text: 'Año actual'},
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres.fechaAnioActual || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresAnioActual || '0'} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasAnioActual || '0'} personas`},
          ],
          [
            {title: 'SemanaAnterior', text: 'Semana anterior'},
            {title: 'Fecha', text: datosReporte?.fechaSemanaAnterior || ''},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresSemanaAnterior || '0'} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasSemanaAnterior || '0'} personas`},
          ],
          [
            {title: 'Variacion', text: 'Variación'},
            {title: 'ObsVariacion', text: 'Con respecto a la semana anterior'},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.variacionSemanaHogares || '0'} hogares ${datosReporte?.datosPaginaSiete?.variacionSemanaHogares < 0 ? 'menos' : 'más'}`},
            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaSiete?.porcentajeVariacionSemanaHogares || '0'}%)`},
          ],
          [
            {title: 'AnioAnterior', text: 'Año anterior'},
            {title: 'Fecha', text: `${datosReporte?.datosPaginaTres.fechaAnioAnterior || ''}`},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresAnioAnterior || '0'} hogares`},
            {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasAnioAnterior || '0'} personas`},
          ],
          [
            {title: 'Variacion', text: 'Variación'},
            {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
            {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.variacionAnioHogares || '0'} hogares ${datosReporte?.datosPaginaSiete?.variacionAnioHogares < 0 ? 'menos' : 'más'}`},
            {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaSiete?.porcentajeVariacionAnioHogares || '0'}%)`},
          ],
        ],
        logoSrc: '/dist/img/logo_login.png',
        cardIcons: [
          '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
          '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
          '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
          '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
          '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
        ]
      });
      canvasRefOcho.current?.draw({
        title:"Lugares de ocurrencia del desplazamiento forzado intraurbano",
        graficaUnoData: datosReporte?.datosPaginaOcho?.graficaUnoData?.map(item => ({
          comuna: item.comuna,
          barrio: item.barrio,
          hogares: item.hogares_count,
          personas: item.total_personas,
        })) || [],
        textoUno:"Tabla 3. Distribución por Barrios, Comunas  y corregimientos de ocurrencia del Desplazamiento Forzado Intraurbano, semana actual.",
        logoSrc:"/dist/img/logo_login.png",
      });
      canvasRefOchoB.current?.draw({
        title: datosReporte?.datosPaginaOchoB?.title ?? '',
        subTitle: datosReporte?.datosPaginaOchoB?.subTitle ?? '',
        graficaUnoData: datosReporte?.datosPaginaOchoB?.graficaUnoData ?? [],
        graficaDosData: datosReporte?.datosPaginaOchoB?.graficaDosData ?? [],
        graficaTresData: datosReporte?.datosPaginaOchoB?.graficaTresData ?? [],
        textoGraficoUno: datosReporte?.datosPaginaOchoB?.textoGraficoUno ?? '',
        textoGraficoDos: datosReporte?.datosPaginaOchoB?.textoGraficoDos ?? '',
        textoGraficoTres: datosReporte?.datosPaginaOchoB?.textoGraficoTres ?? '',
        textoCualitativo: [
            datosReporte?.datosPaginaOchoB?.textoCualitativo ?? '',
            datosReporte?.datosPaginaOchoB?.textoCualitativoUno ?? '',
            datosReporte?.datosPaginaOchoB?.textoCualitativoDos ?? '',
            datosReporte?.datosPaginaOchoB?.textoCualitativoTres ?? '',
        ],
        titleSquareText:"2.2",
        logoSrc:"/dist/img/logo_login.png",
      });
      canvasRefDiez.current?.draw({
        title: 'Causas del DFI Semana actual',
        subTitle: 'Tabla 4. Causas del Desplazamiento Forzado Intraurbano semana actual.',
        textoUno: datosReporte?.datosPaginaDiez?.textoResumen || '',
        logoSrc: '/dist/img/logo_login.png',
        tableTitle: '​CAUSAS DEL DESPLAZAMIENTO INTRAURBANO',
        tableData: datosReporte?.datosPaginaDiez?.graficaUnoData?.map(item => ({
          comuna: item.comuna,
          categoria: item.categoria,
          hecho: item.factor_incidencia,
          totalHogares: String(item.hogares),
          totalPersonas: String(item.personas),
        })) || [],
      });
      canvasRefOnce.current?.draw({
        title:"Advertencias de posibles riesgos",
        subTitle: datosReporte?.datosPaginaOnce?.subtitulo || '',
        texto: `${datosReporte?.datosPaginaOnce?.textoResumen || ''}`,
        logoSrc:"/dist/img/logo_login.png",
        bgColor:"#ffffffff",
      });
      canvasRefDoce.current?.draw({
        title:"Advertencias de posibles riesgos",
        subTitle: datosReporte?.datosPaginaDoce?.subtitulo || '',
        texto: `${datosReporte?.datosPaginaDoce?.textoResumen || ''}`,
        logoSrc:"/dist/img/logo_login.png",
        bgColor:"#ffffffff",
      });
      canvasRefTrece.current?.draw({
        title:"Glosario",
        glosarioData: [
          { termino: 'Hechos victimizantes', definicion: 'hechos de violencia cometidos contra personas, grupos o comunidades ocurridos en el desarrollo del conflicto armado, por cuya materialización se vulneran derechos a la vida, integridad, seguridad y libertad personal; uno de ellos es el desplazamiento forzado.' },
          { termino: 'Desplazamiento forzado', definicion: 'cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar su vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas.' },
          { termino: 'Recepción de personas desplazadas en Medellín', definicion: 'aquellas personas que siendo desplazadas por el conflicto armado o circunstancias conexas a este, migran hacia la ciudad de Medellín, por lo cual se constituye en el municipio receptor de dicha población.' },
          { termino: 'Desplazamiento forzado intraurbano', definicion: 'se denomina intraurbano cuando la persona es desplazada de determinado lugar de la ciudad y se asienta en otro sector de la misma ciudad, en este caso, de Medellín.' },
          { termino: 'Advertencias de posibles riesgos', definicion: 'situaciones que indican la posible inminencia o materialización de algún riesgo en la ciudad, asociado a la ocurrencia de hechos victimizantes que afecten a determinados grupos o comunidades, y por tanto requieren de medidas de prevención urgente.' },
        ],
        logoSrc:"/dist/img/logo_login.png",
      });
    }, []);


    const exportPDF = async() => {
      try {
        const img1 = canvasRef.current?.getDataUrl?.() ?? null;
        const img2 = canvasRefDos.current?.getDataUrl?.() ?? null;
        const img3 = canvasRefTres.current?.getDataUrl?.() ?? null;
        const img4 = canvasRefCuatro.current?.getDataUrl?.() ?? null;
        const img5 = canvasRefCinco.current?.getDataUrl?.() ?? null;
        const img6 = canvasRefSeis.current?.getDataUrl?.() ?? null;
        const img6B = canvasRefSeisB.current?.getDataUrl?.() ?? null;
        const img7 = canvasRefSiete.current?.getDataUrl?.() ?? null;
        const img8 = canvasRefOcho.current?.getDataUrl?.() ?? null;
        const img8B = canvasRefOchoB.current?.getDataUrl?.() ?? null;
        const img10 = canvasRefDiez.current?.getDataUrl?.() ?? null;
        const img11 = datosReporte?.datosPaginaOnce?.subtitulo? canvasRefOnce.current?.getDataUrl?.() ?? null: null;
        const img12 = datosReporte?.datosPaginaDoce?.subtitulo? canvasRefDoce.current?.getDataUrl?.() ?? null: null;
        const img13 = canvasRefTrece.current?.getDataUrl?.() ?? null;
        
        if (!img1 && !img2 && !img3 && !img4 && !img5 && !img6 && !img6B && !img7 && !img8 && !img8B && !img10 && !img11 && !img12 && !img13) return;

        const pdf = new jsPDF('landscape', 'mm', 'letter');
        const margin = 10;
        const pageW = pdf.internal.pageSize.getWidth() - margin * 2;

        if (img1) {
          const props1 = pdf.getImageProperties(img1);
          const h1 = (props1.height * pageW) / props1.width;
          pdf.addImage(img1, 'PNG', margin, margin, pageW, h1);
        }

        if (img2) {
          pdf.addPage();
          const props2 = pdf.getImageProperties(img2);
          const h2 = (props2.height * pageW) / props2.width;
          pdf.addImage(img2, 'PNG', margin, margin, pageW, h2);
        }

        if (img3) {
          pdf.addPage();
          const props3 = pdf.getImageProperties(img3);
          const h3 = (props3.height * pageW) / props3.width;
          pdf.addImage(img3, 'PNG', margin, margin, pageW, h3);
        }
        
        if (img4) {
          pdf.addPage();
          const props4 = pdf.getImageProperties(img4);
          const h4 = (props4.height * pageW) / props4.width;
          pdf.addImage(img4, 'PNG', margin, margin, pageW, h4);
        }

        if (img5) {
          pdf.addPage();
          const props5 = pdf.getImageProperties(img5);
          const h5 = (props5.height * pageW) / props5.width;
          pdf.addImage(img5, 'PNG', margin, margin, pageW, h5);
        }

        if (img6) {
          pdf.addPage();
          const props6 = pdf.getImageProperties(img6);
          const h6 = (props6.height * pageW) / props6.width;
          pdf.addImage(img6, 'PNG', margin, margin, pageW, h6);
        }

        if (img6B) {
          pdf.addPage();
          const props6B = pdf.getImageProperties(img6B);
          const h6B = (props6B.height * pageW) / props6B.width;
          pdf.addImage(img6B, 'PNG', margin, margin, pageW, h6B);
        }

        if (img7) {
          pdf.addPage();
          const props7 = pdf.getImageProperties(img7);
          const h7 = (props7.height * pageW) / props7.width;
          pdf.addImage(img7, 'PNG', margin, margin, pageW, h7);
        }

        if (img8) {
          pdf.addPage();
          const props8 = pdf.getImageProperties(img8);
          const h8 = (props8.height * pageW) / props8.width;
          pdf.addImage(img8, 'PNG', margin, margin, pageW, h8);
        }

        if (img8B) {
          pdf.addPage();
          const props8B = pdf.getImageProperties(img8B);
          const h8B = (props8B.height * pageW) / props8B.width;
          pdf.addImage(img8B, 'PNG', margin, margin, pageW, h8B);
        }

        if (img10) {
          pdf.addPage();
          const props10 = pdf.getImageProperties(img10);
          const h10 = (props10.height * pageW) / props10.width;
          pdf.addImage(img10, 'PNG', margin, margin, pageW, h10);
        }

        if (img11) {
          pdf.addPage();
          const props11 = pdf.getImageProperties(img11);
          const h11 = (props11.height * pageW) / props11.width;
          pdf.addImage(img11, 'PNG', margin, margin, pageW, h11);
        }

        if (img12) {
          pdf.addPage();
          const props12 = pdf.getImageProperties(img12);
          const h12 = (props12.height * pageW) / props12.width;
          pdf.addImage(img12, 'PNG', margin, margin, pageW, h12);
        }

        if (img13) {
          pdf.addPage();
          const props13 = pdf.getImageProperties(img13);
          const h13 = (props13.height * pageW) / props13.width;
          pdf.addImage(img13, 'PNG', margin, margin, pageW, h13);
        }
        
        pdf.save(`reporte_semanal_${(new Date()).toISOString().slice(0,10)}.pdf`);
      } catch (err) {
        console.error(err);
        setSwalProps({ show: true, title: 'Error', text: 'No se pudo generar el PDF.' });
      }
    }

    useEffect(() => {
      async function fetchReporte(id) {
          if (id !== '0') {
          setCargando(true);
          await apiService.get('/diagnostico/reportesemanal/obtenerreporte/' + id, token)
          .then((response) => {
              if (response.status === 200) {
                  setDatosReporte(response.data);
                  setCargando(false);
              } else {
                  Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                  setCargando(false);
              }
          })
          .catch((error) => {
              Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
              setCargando(false);
          });
        }
      }
      fetchReporte(id);
    }, [id]);

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Reporte semanal</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/caracterizacion/reportes" > Reportes</NavLink></li>
                                <li className="breadcrumb-item active"> Reportes</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                  <Card>
                    <Card.Body>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button className="btn btn-sm btn-secondary" onClick={exportPDF}>
                          Descargar PDF
                        </button>
                      </div>
                    </Card.Body>
                  </Card>
                  <div className="card">
                    {id !== '0' && datosReporte && <div className="card-body">
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div style={{ width: '100%', overflow: 'hidden' }}>
                          <GetPaginaUno ref={canvasRef}
                            title="Desplazamiento Forzado"
                            subTitle="en Medell&iacute;n"
                            TituloObservacion={`Informe Semanal | del ${datosReporte?.fechaSemanaActual || ''}`}
                            observations={`Construido con base en los registros del Equipo de Atención y Reparación a Víctimas (EARV), referentes a la atención de personas que declaran hechos victimizantes ante la Personería, Defensoría o Procuraduría, ocurridos en los últimos tres meses anteriores a la atención, según lo ordenado por la Ley 1448 de 2011, artículo 47, modificado por la Ley 2421 de 2024.`}
                            logoSrc="/dist/img/logo_login.png"
                          />
                         <div style={{ height: 12 }} />
                         <GetPaginaDos
                           ref={canvasRefDos}
                           title="Contenido"
                           content={[
                             'Recepción en Medellín de población desplazada',
                             'Desplazamiento Forzado Intraurbano (DFI)',
                             'Advertencias sobre posibles riesgos',
                             'Glosario'
                           ]}
                           footerText="Datos calculados y presentados según la fecha en la que se realizó la atención."
                           tipoInforme="Semanal"

                           logoSrc="/dist/img/logo_login.png"
                         />
                        <div style={{ height: 12 }} />
                        <GetPaginaTres
                          ref={canvasRefTres}
                          title="Recepción en Medellín de población desplazada"
                          textoUno="*Estos datos no incluyen los Desplazamientos Forzados Intraurbanos (DFI)."
                          content={[
                            [
                              {title: 'SemanaActual', text: 'Semana actual' },
                              {title: 'Fecha', text: datosReporte?.fechaSemanaActual || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresSemanaActual || 0} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasSemanaActual || 0} personas`},
                            ],
                            [
                              {title: 'AnioActual', text: 'Año actual'},
                              {title: 'Fecha', text: datosReporte?.datosPaginaTres.fechaAnioActual || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresAnioActual || 0} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasAnioActual || 0} personas`},
                            ],
                            [
                              {title: 'SemanaAnterior', text: 'Semana anterior'},
                              {title: 'Fecha', text: datosReporte?.fechaSemanaAnterior || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresSemanaAnterior || 0} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasSemanaAnterior || 0} personas`},
                            ],
                            [
                              {title: 'Variacion', text: 'Variación'},
                              {title: 'ObsVariacion', text: 'Con respecto a la semana anterior'},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.variacionSemanaHogares > 0 ? '+' : ''}${datosReporte?.datosPaginaTres.variacionSemanaHogares || ''} hogares`},
                              {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres.porcentajeVariacionSemanaHogares || ''}%)`},
                            ],
                            [
                              {title: 'AnioAnterior', text: 'Año anterior'},
                              {title: 'Fecha', text: datosReporte?.datosPaginaTres.fechaAnioAnterior || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.hogaresAnioAnterior || 0} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaTres.personasAnioAnterior || 0} personas`},
                            ],
                            [
                              {title: 'Variacion', text: 'Variación'},
                              {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaTres.variacionAnioHogares > 0 ? '+' : ''}${datosReporte?.datosPaginaTres.variacionAnioHogares || ''} hogares`},
                              {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaTres.porcentajeVariacionAnioHogares || ''}%)`},
                            ],
                          ]}
                          logoSrc="/dist/img/logo_login.png"
                          cardIcons={[
                            '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
                            '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
                            '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                            '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                          ]}
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaCuatro
                          ref={canvasRefCuatro}
                          title="Recepción de población desplazada proveniente de otros municipios de ANTIOQUIA"
                          subTitle=""
                          textoUno="Tabla 1. Principales subregiones con mayor expulsión de población desplazada proveniente de Antioquia con recepción en Medellín, semana actual."
                          textoDos=""
                          logoSrc="/dist/img/logo_login.png"
                          tableData={datosReporte?.datosPaginaCuatro?.rows?.map(item => ({
                            subregion: item.subregion,
                            municipio: item.municipio,
                            totalHogares: String(item.totalHogares),
                            totalPersonas: String(item.totalPersonas),
                          })) || []}
                          resumenTabla={[
                            { label: 'Total Antioquia (sin Medellín)', value: `${datosReporte?.datosPaginaCuatro?.hogaresDepartamento ?? ''} Hogares` },
                            { label: 'Porcentaje en Antioquia (sin Medellín)', value: `${datosReporte?.datosPaginaCuatro?.porcentajeHogares ?? ''} %` },
                          ]}
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaCinco
                          ref={canvasRefCinco}
                          title="Recepción de población desplazada proveniente de OTROS DEPARTAMENTOS"
                          subTitle=""
                          textoUno="Tabla 2. Principales departamentos expulsores de población desplazada con recepción en Medellín, semana actual."
                          textoDos=""
                          logoSrc="/dist/img/logo_login.png"
                          tableData={datosReporte?.datosPaginaCinco?.rows?.map(item => ({
                            departamento: item.departamento,
                            municipio: item.municipio,
                            totalHogares: String(item.hogares_count),
                            totalPersonas: String(item.total_personas),
                            totalPersonasDepartamento : String(item.totalPersonasDepartamento)
                          })) || []}
                          resumenTabla={[ 
                            { label: 'Total otros departamentos', value: `${datosReporte?.datosPaginaCinco?.hogaresOtrosDepartamento ?? ''} Hogares` },
                            { label: 'Porcentaje de otros departamentos', value: `${datosReporte?.datosPaginaCinco?.porcentajeHogares ?? ''} %` },
                          ]}
                        />
                        <div style={{ height: 12 }} />
                         <GetPaginaSeis
                           ref={canvasRefSeis}
                           title="Recepción de población desplazada proveniente de otros municipios y departamentos"
                           subTitle="Caracteristicas diferenciales - Identidad ÉTNICA"
                           graficaUnoData={ datosReporte?.datosPaginaSeis?.etnias?.map(item => ({
                             categoria: item.min_minoria,
                             valor: item.count,
                           })) || []}
                           graficaDosData={ datosReporte?.datosPaginaSeis?.porDepartamento?.map(item => ({
                             departamento: item.departamento,
                             categoria: item.min_minoria,
                             valor: item.count,
                           })) || []}
                           textoUno="Gráfica 1. Personas atendidas según Identidad étnica otros municipios diferentes de Medellín, semana actual."
                           textoDos="Gráfica 2. Identidad étnica de las personas atendidos otros departamentos, semana actual."
                           footerText="*NARP: Población Negra, Afrocolombiana, Raizal y Palenquera."
                           logoSrc="/dist/img/logo_login.png"
                         />
                        <div style={{ height: 12 }} />
                        <GetPaginaSeisB
                          ref={canvasRefSeisB}
                            title= {datosReporte?.datosPaginaSeisB?.title ?? ''}
                            subTitle= {datosReporte?.datosPaginaSeisB?.subTitle ?? ''}
                            graficaUnoData={datosReporte?.datosPaginaSeisB?.graficaUnoData ?? []}
                            graficaDosData={datosReporte?.datosPaginaSeisB?.graficaDosData ?? []}
                            graficaTresData={datosReporte?.datosPaginaSeisB?.graficaTresData ?? []}
                            textoGraficoUno= {datosReporte?.datosPaginaSeisB?.textoGraficoUno ?? ''}
                            textoGraficoDos= {datosReporte?.datosPaginaSeisB?.textoGraficoDos ?? ''}
                            textoGraficoTres= {datosReporte?.datosPaginaSeisB?.textoGraficoTres ?? ''}
                            textoCualitativo={[
                                datosReporte?.datosPaginaSeisB?.textoCualitativo ?? '',
                                datosReporte?.datosPaginaSeisB?.textoCualitativoDos ?? '',
                                datosReporte?.datosPaginaSeisB?.textoCualitativoTres ?? '',
                                datosReporte?.datosPaginaSeisB?.textoCualitativoCuatro ?? '',
                            ]}
                            titleSquareText="1.4"
                            logoSrc="/dist/img/logo_login.png"
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaSiete
                          ref={canvasRefSiete}
                          title="Desplazamiento Forzado Intraurbano"
                          content={[
                            [
                              {title: 'SemanaActual', text: 'Semana actual'},
                              {title: 'Fecha', text: datosReporte?.fechaSemanaActual || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresSemanaActual || '0'} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasSemanaActual || '0'} personas`},
                            ],
                            [
                              {title: 'AnioActual', text: 'Año actual'},
                              {title: 'Fecha', text: datosReporte?.datosPaginaTres.fechaAnioActual || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresAnioActual || '0'} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasAnioActual || '0'} personas`},
                            ],
                            [
                              {title: 'SemanaAnterior', text: 'Semana anterior'},
                              {title: 'Fecha', text: datosReporte?.fechaSemanaAnterior || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresSemanaAnterior || '0'} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasSemanaAnterior || '0'} personas`},
                            ],
                            [
                              {title: 'Variacion', text: 'Variación'},
                              {title: 'ObsVariacion', text: 'Con respecto a la semana anterior'},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.variacionSemanaHogares || '0'} hogares ${datosReporte?.datosPaginaSiete?.variacionSemanaHogares < 0 ? 'menos' : 'más'}`},
                              {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaSiete?.porcentajeVariacionSemanaHogares || '0'}%)`},
                            ],
                            [
                              {title: 'AnioAnterior', text: 'Año anterior'},
                              {title: 'Fecha', text: datosReporte?.datosPaginaTres.fechaAnioAnterior || ''},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.hogaresAnioAnterior || '0'} hogares`},
                              {title: 'Personas', text: `Integrados por ${datosReporte?.datosPaginaSiete?.personasAnioAnterior || '0'} personas`},
                            ],
                            [
                              {title: 'Variacion', text: 'Variación'},
                              {title: 'ObsVariacion', text: 'Con respecto al año anterior'},
                              {title: 'Hogar', text: `${datosReporte?.datosPaginaSiete?.variacionAnioHogares || '0'} hogares ${datosReporte?.datosPaginaSiete?.variacionAnioHogares < 0 ? 'menos' : 'más'}`},
                              {title: 'Porcentaje', text: `(${datosReporte?.datosPaginaSiete?.porcentajeVariacionAnioHogares || '0'}%)`},
                            ],
                          ]}
                          logoSrc="/dist/img/logo_login.png"
                          cardIcons={[
                            '/dist/img/a9214301-4428-4849-9c30-e7f6abf6a789.png',
                            '/dist/img/a3d2cf32-2ead-4f47-ae6b-010238833eaf.png',
                            '/dist/img/e472b389-7499-40d0-9cf6-2fcd8bf0183c.png',
                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                            '/dist/img/1b8c4f8e-7f0a-477e-aaa1-a5c024eccf9a.png',
                            '/dist/img/2d35004d-cc67-4d39-9996-0f7a4e97f9f3.png',
                          ]}
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaOcho
                          ref={canvasRefOcho}
                          title="Lugares de ocurrencia del Desplazamiento Forzado Intraurbano"
                          graficaUnoData={ datosReporte?.datosPaginaOcho?.graficaUnoData?.map(item => ({
                            comuna: item.comuna,
                            barrio: item.barrio,
                            hogares: item.hogares_count,
                            personas: item.total_personas,
                          })) || []}
                          textoUno="Tabla 3. Distribución por Barrios, Comunas y corregimientos de ocurrencia del Desplazamiento Forzado Intraurbano, semana actual."
                          logoSrc="/dist/img/logo_login.png"
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaSeisB
                          title= {datosReporte?.datosPaginaOchoB?.title ?? ''}
                            subTitle= {datosReporte?.datosPaginaOchoB?.subTitle ?? ''}
                            graficaUnoData={datosReporte?.datosPaginaOchoB?.graficaUnoData ?? []}
                            graficaDosData={datosReporte?.datosPaginaOchoB?.graficaDosData ?? []}
                            graficaTresData={datosReporte?.datosPaginaOchoB?.graficaTresData ?? []}
                            textoGraficoUno= {datosReporte?.datosPaginaOchoB?.textoGraficoUno ?? ''}
                            textoGraficoDos= {datosReporte?.datosPaginaOchoB?.textoGraficoDos ?? ''}
                            textoGraficoTres= {datosReporte?.datosPaginaOchoB?.textoGraficoTres ?? ''}
                            textoCualitativo={[
                                datosReporte?.datosPaginaOchoB?.textoCualitativo ?? '',
                                datosReporte?.datosPaginaOchoB?.textoCualitativoDos ?? '',
                                datosReporte?.datosPaginaOchoB?.textoCualitativoTres ?? '',
                                datosReporte?.datosPaginaOchoB?.textoCualitativoCuatro ?? '',
                            ]}
                            titleSquareText="2.2"
                            logoSrc="/dist/img/logo_login.png"
                        />
                        <div style={{ height: 12 }} />
                        <GetPaginaDiez
                          ref={canvasRefDiez}
                          tipoReporte="semanal"
                          title="Causas del DFI Semana actual"
                          subTitle="Tabla 4. Causas del Desplazamiento Forzado Intraurbano semana actual."
                          textoUno={datosReporte?.datosPaginaDiez?.textoResumen || ''}
                          logoSrc="/dist/img/logo_login.png"
                          tableTitle="​CAUSAS DEL DESPLAZAMIENTO INTRAURBANO"
                          tableData={datosReporte?.datosPaginaDiez?.graficaUnoData?.map(item => ({
                            comuna: item.comuna,
                            categoria: item.categoria,
                            hecho: item.factor_incidencia,
                            totalHogares: String(item.hogares),
                            totalPersonas: String(item.personas),
                          })) || []}
                        />
                        <div style={{ height: 12 }} />
                        {datosReporte?.datosPaginaOnce?.subtitulo && <GetPaginaOnce
                          ref={canvasRefOnce}
                          title="Advertencias de posibles riesgos"
                          subTitle={datosReporte?.datosPaginaOnce?.subtitulo || ''}
                          texto={`${datosReporte?.datosPaginaOnce?.textoResumen || ''}`}
                          logoSrc="/dist/img/logo_login.png"
                          bgColor="#ffffffff"
                        />}
                        <div style={{ height: 12 }} />
                        {datosReporte?.datosPaginaDoce?.subtitulo && <GetPaginaDoce
                          ref={canvasRefDoce}
                          title="Advertencias de posibles riesgos"
                          subTitle={datosReporte?.datosPaginaDoce?.subtitulo || ''}
                          texto={`${datosReporte?.datosPaginaDoce?.textoResumen || ''}`}
                          logoSrc="/dist/img/logo_login.png"
                          bgColor="#ffffffff"
                        />}
                        <div style={{ height: 12 }} />
                        <GetPaginaTrece
                          ref={canvasRefTrece}
                          title="Glosario"
                          glosarioData={[
                            { termino: 'Hechos victimizantes', definicion: 'hechos de violencia cometidos contra personas, grupos o comunidades ocurridos en el desarrollo del conflicto armado, por cuya materialización se vulneran derechos a la vida, integridad, seguridad y libertad personal; uno de ellos es el desplazamiento forzado.' },
                            { termino: 'Desplazamiento forzado', definicion: 'cambio de residencia de una o varias personas o de sus actividades económicas habituales, en contra de su voluntad y condicionadas por la necesidad de preservar su vida e integridad ante hechos de conflicto armado, violencia organizada u otras circunstancias conexas.' },
                            { termino: 'Recepción de personas desplazadas en Medellín', definicion: 'aquellas personas que siendo desplazadas por el conflicto armado o circunstancias conexas a este, migran hacia la ciudad de Medellín, por lo cual se constituye en el municipio receptor de dicha población.' },
                            { termino: 'Desplazamiento forzado intraurbano', definicion: 'se denomina intraurbano cuando la persona es desplazada de determinado lugar de la ciudad y se asienta en otro sector de la misma ciudad, en este caso, de Medellín.' },
                            { termino: 'Advertencias de posibles riesgos', definicion: 'situaciones que indican la posible inminencia o materialización de algún riesgo en la ciudad, asociado a la ocurrencia de hechos victimizantes que afecten a determinados grupos o comunidades, y por tanto requieren de medidas de prevención urgente.' },
                          ]}
                          logoSrc="/dist/img/logo_login.png"
                        />
                        </div>
                      </div>
                    </div>}
                    {id == '0' && <div className="card-body">
                        <h3>No hay seleccionado un reporte para visualizar</h3>
                      </div>}
                  </div>
                </div>
                <SweetAlert2 {...swalProps} didClose={() => setSwalProps({})}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}